import React from 'react';

export const FaceDisgustIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M10.5 21C12.9853 21 15 18.9853 15 16.5C15 14.0147 12.9853 12 10.5 12C8.01472 12 6 14.0147 6 16.5C6 18.9853 8.01472 21 10.5 21Z"
        fill="white"
      />
      <path
        d="M21.5 21C23.9853 21 26 18.9853 26 16.5C26 14.0147 23.9853 12 21.5 12C19.0147 12 17 14.0147 17 16.5C17 18.9853 19.0147 21 21.5 21Z"
        fill="white"
      />
      <path
        d="M14.2899 12.501C14.7035 12.5231 15.0209 12.8763 14.9989 13.2899C14.9768 13.7035 14.6237 14.0209 14.21 13.9989C13.1929 13.9447 12.2213 13.6953 11.3932 13.1186C10.558 12.537 9.93308 11.6671 9.53869 10.4878C9.40731 10.095 9.61925 9.67007 10.0121 9.53869C10.4049 9.40731 10.8299 9.61925 10.9612 10.0121C11.2715 10.9398 11.7235 11.5207 12.2504 11.8877C12.7846 12.2597 13.4607 12.4568 14.2899 12.501Z"
        fill="#402A32"
      />
      <path
        d="M17.71 12.501C17.2964 12.5231 16.979 12.8763 17.001 13.2899C17.0231 13.7035 17.3763 14.0209 17.7899 13.9989C18.807 13.9447 19.7786 13.6953 20.6067 13.1186C21.442 12.537 22.0668 11.6671 22.4612 10.4878C22.5926 10.095 22.3807 9.67007 21.9878 9.53869C21.595 9.40731 21.1701 9.61925 21.0387 10.0121C20.7284 10.9398 20.2764 11.5207 19.7495 11.8877C19.2153 12.2597 18.5392 12.4568 17.71 12.501Z"
        fill="#402A32"
      />
      <path
        d="M16 24C13.9953 24 13.0659 25.1042 12.8944 25.4472C12.6474 25.9412 12.0467 26.1414 11.5527 25.8944C11.0588 25.6474 10.8585 25.0467 11.1055 24.5527C11.6007 23.5624 13.2046 22 16 22C18.7953 22 20.3992 23.5624 20.8944 24.5527C21.1414 25.0467 20.9412 25.6474 20.4472 25.8944C19.9532 26.1414 19.3525 25.9412 19.1055 25.4472C18.934 25.1042 18.0046 24 16 24Z"
        fill="#402A32"
      />
      <path
        d="M14 17C14 18.1045 13.1046 19 12 19C10.8954 19 10 18.1045 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17Z"
        fill="#402A32"
      />
      <path
        d="M22 17C22 18.1045 21.1046 19 20 19C18.8954 19 18 18.1045 18 17C18 15.8954 18.8954 15 20 15C21.1046 15 22 15.8954 22 17Z"
        fill="#402A32"
      />
    </svg>
  );
};
